var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 59,
    viewBox: "0 0 39 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5639 25.8944C12.5157 23.9606 9.92749 21.9611 9.92749 18.8472C9.92749 15.2744 13.5084 12.7833 19.5002 12.7833C25.8111 12.7833 28.1511 15.5694 28.3639 19.6667H36.1993C35.9511 14.0289 32.2284 8.85 24.8184 7.17833V0H14.182V7.08C7.30386 8.45667 1.77295 12.5867 1.77295 18.9128C1.77295 26.4844 8.54477 30.2539 18.4366 32.45C27.3002 34.4167 29.073 37.3011 29.073 40.3494C29.073 42.6111 27.3357 46.2167 19.5002 46.2167C12.1966 46.2167 9.32477 43.2011 8.93477 39.3333H1.13477C1.56022 46.5117 7.37477 50.5433 14.182 51.8872V59H24.8184V51.9528C31.732 50.74 37.2275 47.0361 37.2275 40.3167C37.2275 31.0078 28.612 27.8283 20.5639 25.8944Z",
    fill: "#4A4A4A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.d1ff26f242be26c1321b237eb0ca52e4.svg";
export { ForwardRef as ReactComponent };